import { useSmartPools } from '@app/hooks/plugins/useSmartPools';
import { Address } from '@thirdweb-dev/sdk';
import { useMemo } from 'react';

export function useProviderStrategies(poolAddress: Address | undefined) {
  const { data } = useSmartPools();

  const poolStrategies = useMemo(() => {
    if (!data || !poolAddress) {
      return;
    }

    const strategies = data.pools[poolAddress.toLowerCase()];

    return strategies ?? [];
  }, [data, poolAddress]);

  return {
    strategies: poolStrategies
  };
}
